import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';
import AlternateFlow from 'svg-icons/alternate-flow.svg';
import Call from 'svg-icons/call.svg';
import Email from 'svg-icons/email.svg';
import EnrollmentComplete from 'svg-icons/enrollment-complete.svg';
import Family from 'svg-icons/family.svg';
import Growth from 'svg-icons/growth.svg';
import HeadsetMic from 'svg-icons/headset_mic.svg';
import InfographicScreen from 'svg-icons/infographic-screen.svg';
import LpnTile from 'svg-icons/lpn-tile.svg';
import Questions from 'svg-icons/questions.svg';
import Startup from 'svg-icons/startup.svg';
import Target from 'svg-icons/target.svg';
import CollegePlanning from 'svg-icons/college-planning.svg';
import SocialMediaMarketing from 'svg-icons/social-media-marketing.svg';
import Icon529Piggy from 'svg-icons/529-piggy.svg';
import StudentLoanGlossary from 'svg-icons/student-loan-glossary.svg';
import SecureYourFuture from 'svg-icons/secure-your-future.svg';
import MarketingStrategy from 'svg-icons/marketing-strategy.svg';
import WomanOnLaptopWorking from 'svg-icons/woman-on-laptop-working.svg';
import CoinFolder from 'svg-icons/coin-folder.svg';
import CalculatorIllustration from 'svg-icons/calculator-illustration.svg';
import CrystalBall from 'svg-icons/crystal-ball.svg';
import MailSent from 'svg-icons/tuition-assistance/mail-sent.svg';
import PeopleOutline24 from 'svg-icons/tuition-assistance/people-outline-24.svg';
import Visa from 'svg-icons/tuition-assistance/visa.svg';
import Mentoring from 'svg-icons/tuition-assistance/mentoring.svg';
import Working from 'svg-icons/pslf/working.svg';
import OnlineTest from 'svg-icons/pslf/online-test.svg';
import DeptOfEd from 'svg-icons/pslf/dept-of-ed.svg';

type IconComponent = ComponentLike<{ Element: SVGSVGElement }>;

const ICONS = {
  'alternate-flow': AlternateFlow,
  call: Call,
  email: Email,
  'enrollment-complete': EnrollmentComplete,
  family: Family,
  growth: Growth,
  headset_mic: HeadsetMic,
  'infographic-screen': InfographicScreen,
  'lpn-tile': LpnTile,
  questions: Questions,
  startup: Startup,
  target: Target,
  'college-planning': CollegePlanning,
  'social-media-marketing': SocialMediaMarketing,
  '529-piggy': Icon529Piggy,
  'student-loan-glossary': StudentLoanGlossary,
  'secure-your-future': SecureYourFuture,
  'marketing-strategy': MarketingStrategy,
  'woman-on-laptop-working': WomanOnLaptopWorking,
  'coin-folder': CoinFolder,
  'calculator-illustration': CalculatorIllustration,
  'crystal-ball': CrystalBall,
  'mail-sent': MailSent,
  'people-outline-24': PeopleOutline24,
  visa: Visa,
  mentoring: Mentoring,
  working: Working,
  'online-test': OnlineTest,
  'dept-of-ed': DeptOfEd,
} satisfies Record<string, IconComponent>;

export type SvgName = keyof typeof ICONS;

export interface SvgSignature {
  Element: SVGSVGElement;
  Args: { name: SvgName };
}

export default class Svg extends Component<SvgSignature> {
  get icon(): IconComponent {
    return ICONS[this.args.name];
  }

  <template>
    {{#let this.icon as |Icon|}}
      <Icon ...attributes />
    {{/let}}
  </template>
}
